
import { KeyPressEvents, serialize } from './serialize'
import { notifySendKeyboardEvent, notifySendKeyboardEventDebug } from '../actions/toolbar'
import { ModifierKeys } from './modifiers'

/**
 * @param {*} keyPressEvent - KeyPressEvents
 * @param {*} modifierKeyName - ModifierKeyNames
 */
export function mapModifierKey2KeyMessage (keyPressEvent, modifierKeyName) {
  return {
    action: keyPressEvent,
    code: ModifierKeys[modifierKeyName].code,
    key: ModifierKeys[modifierKeyName].key,
    location: ModifierKeys[modifierKeyName].location,
    which: ModifierKeys[modifierKeyName].which,
    modifierState: 0
  }
}

/**
 * @param {*} keyboardEvent - sent by the browser
 */
export function mapKeyboardEvent2KeyMessage (keyboardEvent) {
  const types = {
    'keydown': KeyPressEvents.KEY_DOWN,
    'keyup': KeyPressEvents.KEY_UP,
  }

  const isCapsNumScrollLock = ['CapsLock', 'NumLock', 'ScrollLock'].includes(keyboardEvent.code)
  const modifierState = isCapsNumScrollLock
    ? keyboardEvent.getModifierState(keyboardEvent.code) ? 1 : 0
    : 0

  const keyMessage = {
    action: types[keyboardEvent.type],
    code: keyboardEvent.code,
    key: keyboardEvent.key,
    location: keyboardEvent.location,
    which: keyboardEvent.which || keyboardEvent.keyCode || 0,
    /*
     * this field is relevant just for CapsLock NumLock ScrollLock keyDown events
     * 1 means CapsLock got enabled with the last keydown event
     * 0 means CapsLock got enabled with the last keydown event
     * for keyUp events it is not taken in consideration on agent side, though it gets constructed the same way
     */
    modifierState,

    repeat: keyboardEvent.repeat,
    metaKey: keyboardEvent.metaKey,
    ctrlKey: keyboardEvent.ctrlKey,
    shiftKey: keyboardEvent.shiftKey,
  }
  return keyMessage
}

export function transformToAction (keyMessage) {
  const serializedData = serialize(keyMessage)
  const databuffer = new Uint8Array(serializedData)
  const action = notifySendKeyboardEvent(databuffer)
  return action
}

export function transformToActionDebug (keyMessage) {
  const serializedData = serialize(keyMessage)
  const databuffer = new Uint8Array(serializedData)
  const action = notifySendKeyboardEventDebug({ payload: databuffer, meta: keyMessage })
  return action
}

